import { createSlice } from "@reduxjs/toolkit";

export const filterStore = createSlice({
  name: "filters",
  initialState: {
    meModeActive: false,
    meModeTriggeredByKanban: false,
  },
  reducers: {
    toggleMeMode: (state) => {
      state.meModeActive = !state.meModeActive;
    },
    setMeMode(state, action) {
      state.meModeActive = action.payload;
    },
    setMeModeTriggeredByKanban(state, action) {
      state.meModeTriggeredByKanban = action.payload;
    },
  },
});

export const { toggleMeMode, setMeMode, setMeModeTriggeredByKanban } =
  filterStore.actions;

export default filterStore.reducer;
